import { CommonPageALMeta } from '@lemon8/web-app-shared/ssr';
import { useAtomValue } from 'jotai';
import { DeepLinkBuildingProps } from '~/utils/active/schema';
import { useCompletedActiveSchema } from '~/utils/active/use-completed-active-schema';
import { $CurrentAvailableUserOrNull } from '../shared/atoms/current-user';
import { loadable } from 'jotai/utils';
import { $SEOCurrentTraffic } from 'shared/atoms/common/traffic';

export const UserFacebookALMeta = () => {
  const getSchemaOption: () => DeepLinkBuildingProps = () => {
    const loadableUser = useAtomValue(loadable($CurrentAvailableUserOrNull));

    if (loadableUser.state !== 'hasData' || !loadableUser.data) {
      return { pageType: 'feed', categoryId: 0 };
    }
    return { pageType: 'user', userId: loadableUser.data.userId };
  };

  const schemaOption = getSchemaOption();

  const alMetaInfo = {
    openUrl: useCompletedActiveSchema(
      {
        ...schemaOption,
        pid: 'seo_al_fb',
      },
      {
        enterPosition: 'seo_al_fb',
      },
    ),
    webUrl: useAtomValue($SEOCurrentTraffic).canonicalUrl,
  };

  return <CommonPageALMeta {...alMetaInfo} />;
};
